// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".portal-grouped-list[data-v-2e2234f5]{max-width:100%}.v-subheader[data-v-2e2234f5]{height:100%!important}.v-list-item__title[data-v-2e2234f5]{white-space:normal!important}.maxHeight[data-v-2e2234f5]{height:calc(100vh - 178px)}.fillOut-grouped-list[data-v-2e2234f5] .maxHeightFull{max-height:10000px}.cursorClick[data-v-2e2234f5]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
